<template>
  <div>
    <div class="fillter_box row m-0 p-0">
      <common-date-picker
        :label="''"
        :currentValue="dateStatus.currentValue"
        :currentOptions="dateStatus.dateOption"
        @input="v => {
                this.registrationDate.startDate = v.startDate,
                this.registrationDate.endDate = v.endDate,
                this.init()
              }"
      />
      <!--      <img class="excel_down_btn float-right" src="/img/icon/icon_excel_down.png" height="32" width="120"/>-->
      <button class="excel_down_btn excel_down_btn_ex shadow-none beta">이력다운로드</button>
    </div>
    <common-data-table
      hover
      :totalPage="totalPage"
      :curPage="curPage"
      class="col-12  p-0"
    >
      <template slot="header">
        <b-thead>
          <b-tr>
            <b-th>출발일시</b-th>
            <b-th>출발위치</b-th>
            <b-th>도착일시</b-th>
            <b-th>도착위치</b-th>
            <b-th>상태</b-th>
            <b-th>운행시간</b-th>
            <b-th>운행거리</b-th>
            <b-th>공회전시간</b-th>
            <b-th>제동시간/횟수	</b-th>
            <b-th>급가속/급감속 횟수</b-th>
            <b-th>최대/최소 RPM</b-th>
          </b-tr>
        </b-thead>
      </template>
      <template slot="body">
        <b-tbody>
          <b-tr v-for="(item, index) in items" :key="index">
            <b-td>{{ item.sdate }}</b-td>
            <b-td class="beta">출발위치</b-td>
            <b-td>{{ item.sdate }}</b-td>
            <b-td class="beta">도착위치</b-td>
            <b-td>{{ item.state }}</b-td>
            <b-td>{{ item.time }}</b-td>
            <b-td>{{ item.otm }}</b-td>
            <b-td>{{ item.avgzerotime }}</b-td>
            <b-td>{{ item.avgbrktime }} / {{ item.avgbrkcnt }}</b-td>
            <b-td>{{ item.speedupcnt }} / {{ item.speeddowncnt }}</b-td>
            <b-td>{{ item.maxrpm }} / {{ item.minrpm }}</b-td>
          </b-tr>
        </b-tbody>
      </template>
    </common-data-table>
  </div>
</template>

<script>
import commonDataTable from '@/components/common/table/DataTable'
import commonDatePicker from '@/components/common/datepicker/DatePicker'
import ax from '@/api/location'

export default {
  name: 'HistoryDrive',
  components: {
    commonDataTable,
    commonDatePicker
  },
  data () {
    return {
      dateStatus: {
        currentValue: null,
        dateOption: [
          {
            text: '오늘',
            value: {
              startDate: this.$moment(new Date()).format('YYYYMMDD'),
              endDate: this.$moment(new Date()).format('YYYYMMDD')
            }
          },
          {
            text: '내일',
            value: {
              startDate: this.$moment(new Date()).add(1, 'day').format('YYYYMMDD'),
              endDate: this.$moment(new Date()).add(1, 'day').format('YYYYMMDD')
            }
          },
          {
            text: '이번달',
            value: {
              startDate: this.$moment(new Date()).format('YYYYMM01'),
              endDate: this.$moment(new Date()).endOf('month').format('YYYYMMDD')
            }
          }
        ],
      },
      registrationDate: {
        startDate: this.$moment(new Date()).format('YYYYMMDD'),
        endDate: this.$moment(new Date()).format('YYYYMMDD')
      },
      curPage: parseInt(this.$route.query.page) || 1,
      totalPage: 1,
      items: []
    }
  },
  watch: {
    '$route.query': function () {
      this.curPage = parseInt(this.$route.query.page) || 1
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      ax.historyLocations(this.$route.params.seq, this.registrationDate.startDate, this.registrationDate.endDate, this.curPage, response => {
        if (response) {
          this.items = response.items
          this.totalPage = response.totalPage
        }  else {
          this.items = []
          this.totalPage = 1
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.fillter_box {
  position: relative;
  height: 55px;
}

.excel_down_btn_ex {
  position: absolute;
  top: 4px;
  right: 0px;
}
</style>
